import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable()
export class ProfileService {
  private baseUrl = environment.API;

  constructor(private http: HttpClient) {}

  get() {
    const url = `${this.baseUrl}/users/account/`;

    return this.http.get(url);
  }

  save(account) {
    const url = `${this.baseUrl}/users/account/`;

    return this.http.put(url, account);
  }

  uploadAvatar(file) {
    const url = `${this.baseUrl}/users/account/picture/`;
    const data = new FormData();
    data.append('file', file);
    return this.http.put(url, data, { responseType: 'text' });
  }

  changePassword(params) {
    const url = `${this.baseUrl}/users/account/password/`;

    return this.http.put(url, params);
  }
}
